import { render, staticRenderFns } from "./input-boards.vue?vue&type=template&id=f7692c60&"
import script from "./input-boards.vue?vue&type=script&lang=js&"
export * from "./input-boards.vue?vue&type=script&lang=js&"
import style0 from "./input-boards.vue?vue&type=style&index=0&id=f7692c60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports